import { render } from "./WalletBalance.vue?vue&type=template&id=63614aba"
import script from "./WalletBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletBalance.vue?vue&type=script&setup=true&lang=js"

import "./WalletBalance.vue?vue&type=style&index=0&id=63614aba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/WalletBalance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63614aba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63614aba', __exports__)) {
    api.reload('63614aba', __exports__)
  }
  
  module.hot.accept("./WalletBalance.vue?vue&type=template&id=63614aba", () => {
    api.rerender('63614aba', render)
  })

}


export default __exports__